export default angular.module('edge.gateway.policyjob.app', []).value('policyjob.endpointConfig', {
    'vinlookup': 'gatewayvehicleinfo/lookup',
    'availability': 'gatewayavailability'
}).value('policyjob.xCenterRouteConfig', 'pc');


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/policyjob/app.js
// module id = 1777
// module chunks = 0